export default function($) {
  $(document).ready(function () {
    var setBodyPadding = function() {
      var footerHeight = $('footer').height(),
          padding = footerHeight;

      $('body').css('padding-bottom', padding + 'px');
    }

    setBodyPadding();

    $(window).resize(function() {
      setBodyPadding();
    })

  });
}